export enum IsPrivacyPolicyConfirmed {
    Yes = "1",
    No = "0",
}

export type PrivacyPolicyConfirmed = IsPrivacyPolicyConfirmed;
